import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 flex items-center justify-center">
      <div className="text-center space-y-8">
        {/* Logo/Brand Section */}
        <div className="space-y-4">
          <div className="relative">
            <div className="w-20 h-20 mx-auto bg-gradient-to-br from-blue-600 to-indigo-700 rounded-2xl flex items-center justify-center shadow-lg">
              <svg 
                className="w-10 h-10 text-white" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" 
                />
              </svg>
            </div>
            {/* Pulse animation rings */}
            <div className="absolute inset-0 w-20 h-20 mx-auto rounded-2xl border-2 border-blue-400 animate-ping opacity-20"></div>
            <div className="absolute inset-0 w-20 h-20 mx-auto rounded-2xl border border-blue-300 animate-pulse opacity-30"></div>
          </div>
          
          <h1 className="text-3xl font-bold text-gray-900">
            Lodia Transport
          </h1>
          <p className="text-gray-600 text-lg">
            Logistics Dashboard
          </p>
        </div>

        {/* Loading Animation */}
        <div className="space-y-4">
          {/* Primary spinner */}
          <div className="relative w-16 h-16 mx-auto">
            <div className="absolute inset-0 rounded-full border-4 border-gray-200"></div>
            <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-blue-600 animate-spin"></div>
            <div className="absolute inset-2 rounded-full border-2 border-transparent border-t-indigo-400 animate-spin animation-delay-75"></div>
          </div>

          {/* Loading text with dots animation */}
          <div className="flex items-center justify-center space-x-1">
            <span className="text-gray-700 font-medium">Loading</span>
            <div className="flex space-x-1">
              <div className="w-1 h-1 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
              <div className="w-1 h-1 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
              <div className="w-1 h-1 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
            </div>
          </div>
        </div>

        {/* Progress steps */}
        <div className="space-y-3 max-w-xs mx-auto">
          <div className="flex items-center space-x-3 text-sm">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
            <span className="text-gray-600">Initializing system...</span>
          </div>
          <div className="flex items-center space-x-3 text-sm opacity-70">
            <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse" style={{ animationDelay: '200ms' }}></div>
            <span className="text-gray-600">Loading dashboard...</span>
          </div>
          <div className="flex items-center space-x-3 text-sm opacity-50">
            <div className="w-2 h-2 bg-gray-300 rounded-full animate-pulse" style={{ animationDelay: '400ms' }}></div>
            <span className="text-gray-600">Preparing workspace...</span>
          </div>
        </div>

        {/* Background decoration */}
        <div className="absolute top-20 left-20 w-32 h-32 bg-blue-200 rounded-full opacity-20 animate-float"></div>
        <div className="absolute bottom-20 right-20 w-24 h-24 bg-indigo-200 rounded-full opacity-20 animate-float" style={{ animationDelay: '2s' }}></div>
        <div className="absolute top-1/2 left-10 w-16 h-16 bg-blue-300 rounded-full opacity-10 animate-float" style={{ animationDelay: '1s' }}></div>
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) scale(1); }
          50% { transform: translateY(-20px) scale(1.05); }
        }
        
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        
        .animation-delay-75 {
          animation-delay: 75ms;
        }
      `}</style>
    </div>
  );
};

export default LoadingScreen;
